import FamilyMember from '@/lib/class/FamilyMember'
import { promoteArrayElement } from '@/mixins/utils'
import { getCareReceivers } from '@/sdk/clients/CareReceiver'
import { getUserDetails } from '@/sdk/clients/UserClient'
import store from '@/store'

import createUserObject from './createUserObject'

interface UserData {
  relationship: string
}

const getFamilyMembers = async () => {
  const cachedFamilyMembers: FamilyMember[] = store.getters[
    'family/familyMembers'
  ]()

  if (cachedFamilyMembers && cachedFamilyMembers.length > 0) {
    return cachedFamilyMembers
  }

  const familyMembers: FamilyMember[] = await buildFamily()

  saveFamilyToStore(familyMembers)

  return familyMembers
}

const userIsAccountOwner = (userData: UserData) =>
  ['You', 'Ich selbst'].includes(userData.relationship)

const buildFamily = async () => {
  const userDetails = await getUserDetails()
  const careReceivers = await getCareReceivers()
  let customerIsSelfBooker = false

  const family = careReceivers.map(careReceiver => {
    if (userIsAccountOwner(careReceiver)) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { salutation, ...userData } = userDetails

      careReceiver = {
        ...careReceiver,
        ...userData,
      }

      customerIsSelfBooker = true
    }

    return createUserObject(careReceiver)
  })

  if (!customerIsSelfBooker) {
    family.push(createUserObject({ ...userDetails, relationship: 'You' }))
  }

  return promoteArrayElement(family, 'isCustomer', true)
}

const saveFamilyToStore = (familyMembers: FamilyMember[]) => {
  store.dispatch('family/SAVE_FAMILY_MEMBERS', familyMembers)
  store.dispatch('family/API_HAS_RESPONDED_WITH_DATA')
}

export default getFamilyMembers
